import { createAiHttp } from "./aiHttp";

const aiHttp = createAiHttp();

class InstitutionalTeamService {
  Get(contaId) {
    return aiHttp({
      url: "/institutional-team/" + contaId,
      method: "GET"
    });
  }

  Save(contaId, payload) {
    return aiHttp({
      url: "/institutional-team/" + contaId,
      data: payload,
      method: "PUT"
    });
  }

  ExportDocx(contaId) {
    return aiHttp({
      url: "/institutional-team/" + contaId + "/export",
      method: "GET",
      responseType: "blob"
    });
  }
}

export default new InstitutionalTeamService();
